module.exports = __webpack_public_path__ + "img/card1.d0abfcbf.jpg";